export default "__VITE_ASSET__Qc2SIQt5__"